const regEx = {
  email: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g,
  password: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/,
  datetime: /[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/,
  yyyymmdd: /[0-9]{4}\/[0-9]{2}\/[0-9]{2}$/,
  year: /[1-9]{1}[0-9]{3}$/,
};

export default regEx;
